export default
  mounted: ->
    return unless (this != @$root); # guard against running this in the root component.    
    @autoheight()
    @_resizeHandler = =>
      clearTimeout(@_resizeTimer)
      @_resizeTimer = setTimeout((=> @autoheight()), 100)
    window.addEventListener 'resize', @_resizeHandler
  updated: ->
    return unless (this != @$root); # guard against running this in the root component.    
    @autoheight()
  beforeDestroy: ->
    clearTimeout(@_resizeTimer)
    window.removeEventListener('resize', @_resizeHandler) if @_resizeHandler
  methods:
    autoheight: (id)->
      return @autoheightClass() unless id        
      @autoheightId(id)
    autoheightClass: (classname) ->      
      return unless (@$el?.querySelectorAll?) # guard against components with top-level v-if. comments don't have querySelectorAll
      classname = 'autoheight' unless classname
      #elements = document.getElementsByClassName(classname)
      elements = @$el.querySelectorAll(".#{classname}") # restrict this action to just those in this component      
      elements = Array.from(elements)
      return if elements.length <= 0
      elements.forEach (element, i) =>
        @autoheightElement(element)
    autoheightId: (id) ->
      element = document.getElementById(id)
      @autoheightElement(element)
    autoheightElement: (element) ->
      return unless element
      # Don't bother with invisible elements.
      if (element.offsetWidth <= 0 || element.offsetHeight <= 0)
        return
      elementStyle = window.getComputedStyle(element)
      elementHeight = elementStyle.getPropertyValue('height')
      # get element height, unit
      elementHeightFloat = parseFloat(elementHeight)
      elementHeightUnit = elementHeight.replace(elementHeightFloat, '')
      # get parent element height
      parentHeight = @getParentHeight(element)
      # get sum of children of this parent heights.
      childrenHeight = @getChildrenHeight(element)
      # Set our height to parent height - that sum
      elementHeightNew = (parentHeight - childrenHeight) + '' + elementHeightUnit
      element.style.height = elementHeightNew
    getParentHeight: (element) ->
      # Get parent element
      parent = element.parentElement
      # set the parent to 100%, causes recompute of height
      parentPrevHeight =  parent.style.height
      parent.style.height = '100%'
      parentStyle = window.getComputedStyle(parent)
      parentheight = parentStyle.getPropertyValue('height')
      parent.style.height = parentPrevHeight
      parentHeightFloat = parseFloat(parentheight)
      parentHeightUnit = "px"
      return parentHeightFloat
    getChildrenHeight: (element) ->
      # Get parent element
      parent = element.parentElement
      # Get child elements
      children = parent.children
      # Sum the heights of child elements other than this
      childrenheight = 0
      Array.from(children).forEach (child, v) =>
        if child != element
          childrenheight = childrenheight + parseFloat(@getChildHeight(child))
      return childrenheight
    getChildHeight: (child) ->
      # Don't bother with invisible children.
      return 0 if (child.offsetWidth <= 0 || child.offsetHeight <= 0)
      childheight = parseFloat(window.getComputedStyle(child).getPropertyValue('height'))
      return childheight